<template>
  <div class="socials">
    <a class="contacts-item-link" href="tel:+375447228833"
      >+375 44 722-88-33
    </a>
    <a
      :href="telegramLink"
      target="_blank"
      rel="noopener noreferrer"
      class="icon-wrapper"
    >
      <TelegramActive
        v-if="isWorkingHours"
        class="icon"
        color="#7D919B"
        width="24"
        height="24"
      />
      <Telegram
        v-else
        ref="telegram"
        class="icon"
        color="#7D919B"
        width="24"
        height="24"
      />
    </a>

    <a
      :href="viberLink"
      target="_blank"
      rel="noopener noreferrer"
      class="icon-wrapper"
    >
      <ViberActive
        v-if="isWorkingHours"
        class="icon"
        color="#7D919B"
        width="24"
        height="24"
      />
      <Viber
        v-else
        ref="viber"
        class="icon"
        color="#7D919B"
        width="24"
        height="24"
      />
    </a>
  </div>
</template>

<script>
import Telegram from "@/assets/icons/telegram.svg";
import Viber from "@/assets/icons/viber.svg";
import { telegramLink, viberLink } from "@/utils/constants/socialLinks";
import TelegramActive from "@/assets/icons/telegram-active.svg";
import ViberActive from "@/assets/icons/viber-active.svg";

export default {
  name: "PurchasesFooterSocials",
  components: { Telegram, Viber, TelegramActive, ViberActive },
  data() {
    return {
      telegramLink,
      viberLink,
    };
  },
  computed: {
    isWorkingHours() {
      const now = new Date();
      const day = now.getDay();
      const isWeekday = day >= 1 && day <= 5;

      const options = {
        timeZone: "Europe/Minsk",
        hour12: false,
        hour: "numeric",
      };
      const hour = new Intl.DateTimeFormat("ru-RU", options).format(new Date());
      return isWeekday && hour >= 9 && hour < 17;
    },
  },
};
</script>

<style scoped lang="less">
.socials {
  display: flex;
  align-items: center;
  gap: 4px;
  padding-right: 80px;
  .contacts-item-link {
    font-family: Roboto;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    text-decoration: none;
    color: #79919c;
    padding-right: 20px;
  }

  .icon-wrapper {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    .icon {
      transition: color 0.2s ease, fill 0.2s ease;
    }
  }
}
</style>
